import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';
import * as Constants from './constants';

const FeedInstitution = Record({
    famlyId: '',
    institutionId: '',
    title: '',
    image: '',
});

export const feedInstitionFromApi = institution => new FeedInstitution(institution);

const SwitcherState = Record({
    showFeedChooser: false,
    fetchingInstitution: false,
    institutionsLoaded: false,
    selectedInstitutionId: Constants.MY_FEED_ID,
    feedInstitutions: List(),
});

const switchReducer = handleActions(
    {
        [Actions.showFeedChooser.type]: (state, {payload}) =>
            state.merge({
                showFeedChooser: payload.show,
            }),
        [Actions.fetchFeedInstitutions.type]: state =>
            state.merge({
                institutionsLoaded: false,
                fetchingInstitution: true,
            }),
        [Actions.selectInstitutionId.type]: (state, {payload}) =>
            state.merge({
                selectedInstitutionId: payload.institutionId,
                showFeedChooser: false,
            }),
        [Actions.fetchFeedInstitutionsSuccess.type]: (state, {payload}) =>
            state.merge({
                fetchingInstitution: false,
                institutionsLoaded: true,
                feedInstitutions: payload.institutions,
            }),
        [Actions.fetchFeedInstitutionsFailed.type]: state =>
            state.merge({
                fetchingInstitution: false,
            }),
    },
    new SwitcherState(),
);

export default switchReducer;
